export { default } from './UCASCode';
export type { Props } from './UCASCode';
